import React, {useState} from 'react';
import {SelectInput} from '../utils/SelectInput';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getUsuariosDuck, getUsuariosThunk} from '../oportunidades/duck';
import {responseSelector} from '../utils/utils';

export const SelectSelectores = ({selectorId, token, onSelect, onError}) => {
  const dispatch = useDispatch();

  const [usuarioOption, setUsuarioOption] = useState();
  const [usuariosOptions, setUsuariosOptions] = useState();
  const [usuariosLoadStatus, setUsuariosLoadStatus] = useState();

  const modelUsuarios = useSelector(state => state.getUsuarios);

  const prepareUsuariosOptions = usuarios => {
    const mUsuariosOptions =
      usuarios &&
      usuarios.map(usuario => ({
        value: usuario?.idNumerico,
        label: usuario?.nombre,
      }));

    return mUsuariosOptions;
  };

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(modelUsuarios);

    if (error) {
      onError(errorMessage);
      dispatch(getUsuariosDuck.actions.clear());
    }

    if (data) {
      const mUsuariosOptions = prepareUsuariosOptions(data.items);

      setUsuariosOptions([
        {value: 'todos', label: 'Todos'},
        ...mUsuariosOptions,
      ]);

      setUsuariosLoadStatus('LOADED');
      dispatch(getUsuariosDuck.actions.clear());
    }
  }, [modelUsuarios]);

  useEffect(() => {
    setUsuariosLoadStatus('LOADING');
    dispatch(
      getUsuariosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  useEffect(() => {
    if (usuariosOptions?.length && selectorId) {
      const usuarioSeleccionado = usuariosOptions.find(
        usuarioOption => usuarioOption.value == selectorId,
      );

      if (usuarioSeleccionado) {
        setUsuarioOption(usuarioSeleccionado);
      } else {
        setUsuarioOption({
          value: selectorId,
          label: 'Desconocido',
        });
      }
    } else {
      setUsuarioOption(null);
    }
  }, [selectorId, usuariosOptions]);

  useEffect(() => {
    onSelect(usuarioOption?.value);
  }, [usuarioOption]);

  return (
    <SelectInput
      label="Selector"
      value={usuarioOption}
      options={usuariosOptions}
      setValue={setUsuarioOption}
      disabled={usuariosLoadStatus !== 'LOADED'}
      isLoading={usuariosLoadStatus !== 'LOADED'}
    />
  );
};
